import { BoomGateArrowDownIcon } from './BoomGateArrowDownIcon';

/**
 * author: Michael Richins
 * id D9BD19B7-12DD-4557-9DDA-998688CA3CB5
 * name boom-gate-arrow-down
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/boom-gate-arrow-down.svg
 * tags
 * - Transportation + Road 
 */
export const AutomaticGateDownIcon = BoomGateArrowDownIcon;
export default AutomaticGateDownIcon